var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
var SearchControl = /** @class */ (function (_super) {
    __extends(SearchControl, _super);
    function SearchControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modifiedValue = null;
        _this.keyUpCooldownTimeout = null;
        return _this;
    }
    Object.defineProperty(SearchControl.prototype, "sizingClassNames", {
        get: function () {
            return {
                'is-medium': this.isMobile
            };
        },
        enumerable: false,
        configurable: true
    });
    SearchControl.prototype.data = function () {
        return {
            modifiedValue: this.value
        };
    };
    SearchControl.prototype.mounted = function () {
        if (this.autoFocus) {
            this.$refs.searchInput.focus();
        }
    };
    SearchControl.prototype.onModifiedValueChanged = function () {
        this.$emit('input', this.modifiedValue);
    };
    SearchControl.prototype.onValueChanged = function () {
        this.modifiedValue = this.value;
    };
    SearchControl.prototype.routeEvent = function (name, e) {
        this.$emit(name, e, this.type);
    };
    SearchControl.prototype.search = function () {
        this.$emit('search', this.type);
        this.$refs.searchInput.focus();
    };
    SearchControl.prototype.clear = function () {
        this.$emit('clear', this.type);
        this.$refs.searchInput.focus();
    };
    SearchControl.prototype.mousedown = function (e) {
        if (!this.canFocus) {
            e.preventDefault();
        }
    };
    SearchControl.prototype.keyup = function (e) {
        var _this = this;
        this.routeEvent('keyup', e);
        clearTimeout(this.keyUpCooldownTimeout);
        this.keyUpCooldownTimeout = setTimeout(function () {
            if (_this.modifiedValue != _this.$refs.searchInput.value) {
                _this.modifiedValue = _this.$refs.searchInput.value;
            }
        }, 750);
    };
    SearchControl.prototype.close = function () {
        this.$emit('collapse');
    };
    __decorate([
        Prop({ type: Boolean })
    ], SearchControl.prototype, "isLoading", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], SearchControl.prototype, "isSoftLoading", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], SearchControl.prototype, "disabled", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], SearchControl.prototype, "readonly", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], SearchControl.prototype, "required", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], SearchControl.prototype, "isMobile", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], SearchControl.prototype, "autoFocus", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], SearchControl.prototype, "isExpanded", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], SearchControl.prototype, "closeButton", void 0);
    __decorate([
        Prop({ type: Boolean, default: true })
    ], SearchControl.prototype, "canFocus", void 0);
    __decorate([
        Prop({ type: String })
    ], SearchControl.prototype, "type", void 0);
    __decorate([
        Prop()
    ], SearchControl.prototype, "value", void 0);
    __decorate([
        Watch('modifiedValue')
    ], SearchControl.prototype, "onModifiedValueChanged", null);
    __decorate([
        Watch('value')
    ], SearchControl.prototype, "onValueChanged", null);
    SearchControl = __decorate([
        Component
    ], SearchControl);
    return SearchControl;
}(Vue));
export default SearchControl;
